import React from 'react'
import {
  DiffImageType,
  ImageDiffSlider,
} from 'src/design_system/components/ImageDiffSlider/ImageDiffSlider'
import { resolveUrl } from 'src/strapi/hooks/homeSectionProcessors'

export type DynamicDiffImageType = {
  leftImage: DiffImageType
  rightImage: DiffImageType
}

export type AnyImageDiff = {
  leftImage?: { url?: string; image?: string; alt?: string; data?: any }
  rightImage?: { url?: string; image?: string; alt?: string; data?: any }
  leftAlt?: string | null
  rightAlt?: string | null
}

type DynamicImageDiffProps = {
  images: AnyImageDiff[]
  activeImageIndex: number
}

const getUrl = (m: any | undefined) => {
  const url =
    m?.url ?? m?.image ?? m?.data?.attributes?.url ?? m?.data?.url ?? undefined
  return resolveUrl(url)
}

const getAlt = (d: AnyImageDiff, side: 'left' | 'right') =>
  (side === 'left' ? d.leftAlt : d.rightAlt) ??
  (side === 'left' ? d.leftImage?.alt : d.rightImage?.alt) ??
  ''

export const DynamicImageDiff: React.FC<DynamicImageDiffProps> = ({
  images,
  activeImageIndex,
}) => {
  if (!images?.length) return null

  const idx = Math.min(Math.max(activeImageIndex, 0), images.length - 1)
  const item = images[idx]

  const left = getUrl(item.leftImage)
  const right = getUrl(item.rightImage)
  if (!left || !right) return null

  const leftImage: DiffImageType = { image: left, alt: getAlt(item, 'left') }
  const rightImage: DiffImageType = { image: right, alt: getAlt(item, 'right') }

  return <ImageDiffSlider leftImage={leftImage} rightImage={rightImage} />
}
